module.exports = __webpack_public_path__ + "static/media/guests-blue.061da9fa.svg";